module.exports = __webpack_public_path__ + "img/ec2-dark.84348653.svg";